var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgePlusfree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 16,
    viewBox: "0 0 39 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600098 4C0.600098 1.79086 2.39096 0 4.6001 0H34.6001C36.8092 0 38.6001 1.79086 38.6001 4V12C38.6001 14.2091 36.8092 16 34.6001 16H4.6001C2.39096 16 0.600098 14.2091 0.600098 12V4Z",
    fill: "#8D35C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60029 12.8C12.2513 12.8 14.4003 10.651 14.4003 8C14.4003 5.34903 12.2513 3.2 9.60029 3.2C6.94933 3.2 4.80029 5.34903 4.80029 8C4.80029 10.651 6.94933 12.8 9.60029 12.8ZM10.2003 6.2C10.2003 5.86863 9.93166 5.6 9.60029 5.6C9.26892 5.6 9.00029 5.86863 9.00029 6.2V7.4H7.80029C7.46892 7.4 7.20029 7.66863 7.20029 8C7.20029 8.33137 7.46892 8.6 7.80029 8.6H9.00029V9.8C9.00029 10.1314 9.26892 10.4 9.60029 10.4C9.93166 10.4 10.2003 10.1314 10.2003 9.8V8.6H11.4003C11.7317 8.6 12.0003 8.33137 12.0003 8C12.0003 7.66863 11.7317 7.4 11.4003 7.4H10.2003V6.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4415 8.48204V9.47997H21.9677V12.3874H20.735V9.47997H17.313V8.48204H25.4415ZM18.273 7.52555V3.94475H24.4712V7.52555H18.273ZM19.4954 6.5518H23.2316V4.93232H19.4954V6.5518ZM33.8944 10.3881V11.4068H25.766V10.3881H27.8482V9.02417H26.7018V6.04075H31.7259V5.08771H26.6879V4.08633H32.9587V7.03177H27.9448V8.01934H33.1658V9.02417H31.9089V10.3881H33.8944ZM29.0602 10.3881H30.6831V9.02417H29.0602V10.3881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgePlusfree);
export default __webpack_public_path__ + "static/media/badge_plusfree.2f5e61ffb7226202553b48fb3f6559e1.svg";
export { ForwardRef as ReactComponent };